import { useEffect, useRef } from "react";
import {
  motion,
  useAnimationControls,
  useInView,
  useReducedMotion,
} from "framer-motion";
const EASE = [0.22, 1, 0.36, 1];
export function Line({ children, delay = 0, className = "" }) {
  const controls = useAnimationControls();
  const reduced = useReducedMotion();
  useEffect(() => {
    if (reduced) {
      controls.set({ y: 0 });
      return;
    }
    controls.set({ y: "110%" });
    controls.start({
      y: "0%",
      transition: { duration: 0.9, delay, ease: EASE },
    });
    return () => controls.stop();
  }, [controls, reduced, delay]);
  return (
    <span className={`mask-line ${className}`}>
      <motion.span className="block" initial={false} animate={controls}>
        {children}
      </motion.span>
    </span>
  );
}
export function Reveal({
  children,
  delay = 0,
  y = 28,
  immediate = false,
  className = "",
}) {
  const ref = useRef(null);
  const controls = useAnimationControls();
  const reduced = useReducedMotion();
  const visible = useInView(ref, { once: true, margin: "-60px" });
  const initialized = useRef(false);
  useEffect(() => {
    if (reduced) {
      controls.set({ opacity: 1, y: 0 });
      return;
    }
    if (!initialized.current) {
      controls.set({ opacity: 0, y });
      initialized.current = true;
    }
    if (immediate || visible)
      controls.start({
        opacity: 1,
        y: 0,
        transition: { duration: 0.7, delay, ease: EASE },
      });
  }, [controls, reduced, visible, immediate, delay, y]);
  return (
    <motion.div
      ref={ref}
      className={className}
      initial={false}
      animate={controls}
    >
      {children}
    </motion.div>
  );
}
export const Overline = ({ children, dark = false, className = "" }) => (
  <span
    className={`inline-flex items-center gap-2.5 font-mono text-[11px] font-medium uppercase tracking-[0.22em] ${dark ? "text-slate-400" : "text-slate-500"} ${className}`}
  >
    <span className="h-1.5 w-1.5 bg-gold" aria-hidden="true" />
    {children}
  </span>
);
